import { useTranslation } from "react-i18next";

const NoMessages = () => {
	const { t } = useTranslation();
	return (
		<div className="flex h-full w-full flex-col items-center justify-center gap-1 font-semibold">
			<span className="text-secondary italic">{t("live_page.no_messages")}</span>
		</div>
	);
};

export default NoMessages;
